import { render } from "./ProductsCarousel.vue?vue&type=template&id=f536bc20"
import script from "./ProductsCarousel.vue?vue&type=script&lang=js"
export * from "./ProductsCarousel.vue?vue&type=script&lang=js"

import "./ProductsCarousel.vue?vue&type=style&index=0&id=f536bc20&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__